(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rtp-cart-deal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rtp-cart-deal')) {
    customElements.define('rtp-cart-deal', class extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }
      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
      refresh() {
        fetch(window.routes.cart_url + '?section_id=' + this.dataset.sectionId)
          .then((r) => r.text())
          .then((html) => {
            const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('rtp-cart-deal');
            if (fresh) this.replaceWith(fresh);
          })
          .catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rtp-cart-friends"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rtp-cart-friends')) {
    customElements.define('rtp-cart-friends', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('submit', this.onSubmit.bind(this));
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }
      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
      sectionWrapper() {
        return document.getElementById('shopify-section-' + this.dataset.sectionId);
      }
      swap(html) {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('rtp-cart-friends');
        if (fresh) this.replaceWith(fresh);
        return fresh;
      }
      refresh() {
        fetch(window.routes.cart_url + '?section_id=' + this.dataset.sectionId)
          .then((r) => r.text())
          .then((html) => this.swap(html))
          .catch(() => {});
      }
      onSubmit(event) {
        const form = event.target.closest('form[data-cf-add]');
        if (!form || typeof fetchConfig !== 'function' || !document.getElementById('main-cart-items')) return;
        event.preventDefault();
        const button = form.querySelector('button');
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        const name = form.dataset.cfName;
        const items = document.getElementById('main-cart-items');
        const footer = document.getElementById('main-cart-footer');
        const targets = [
          { key: items.dataset.id, el: items.querySelector('.js-contents'), selector: '.js-contents' },
          { key: 'cart-icon-bubble', el: document.getElementById('cart-icon-bubble'), selector: '.shopify-section' },
          { key: footer ? footer.dataset.id : null, el: footer && footer.querySelector('.js-contents'), selector: '.js-contents' },
        ].filter((t) => t.key && t.el);
        // Section Rendering allows 5 sections per request: items, bubble, footer, this section, deal.
        const deal = document.querySelector('rtp-cart-deal');
        const dealKey = deal ? deal.dataset.sectionId : null;
        const body = JSON.stringify({
          items: [{ id: Number(form.querySelector('[name="id"]').value), quantity: 1 }],
          sections: targets.map((t) => t.key).concat(this.dataset.sectionId, dealKey || []),
          sections_url: window.location.pathname,
        });
        fetch(window.routes.cart_add_url, { ...fetchConfig('javascript'), body })
          .then((r) => r.json())
          .then((state) => {
            if (state.status || !state.sections) throw new Error(state.description || state.message || 'error');
            targets.forEach((t) => {
              const doc = new DOMParser().parseFromString(state.sections[t.key], 'text/html');
              const source = doc.querySelector(t.selector);
              if (source) t.el.innerHTML = source.innerHTML;
            });
            if (deal && dealKey && state.sections[dealKey]) {
              const freshDeal = new DOMParser().parseFromString(state.sections[dealKey], 'text/html').querySelector('rtp-cart-deal');
              if (freshDeal) deal.replaceWith(freshDeal);
            }
            const fresh = this.swap(state.sections[this.dataset.sectionId]);
            const status = (fresh || this).querySelector('[data-cf-status]');
            if (status) status.textContent = name + ' added to your cart.';
          })
          .catch((error) => {
            button.removeAttribute('aria-busy');
            let note = form.parentElement.querySelector('.rtp-cf__error');
            if (!note) {
              note = document.createElement('p');
              note.className = 'rtp-cf__error';
              note.setAttribute('role', 'alert');
              form.after(note);
            }
            note.textContent = error && error.message && error.message !== 'error' ? error.message : "Couldn't add " + name + '. Please try again.';
          });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
